import ApiClient from './ApiClient';

class ProductTemplatesAPI extends ApiClient {
  constructor() {
    super('product_templates', { accountScoped: true });
  }

  sendProduct(templateId, payload) {
    return window.axios.post(`${this.url}/${templateId}/send_product`, payload);
  }

  importTemplates(file) {
    const formData = new FormData();
    formData.append('import_file', file);
    return window.axios.post(`${this.url}/import`, formData);
  }
}

export default new ProductTemplatesAPI();
